"use client";

import * as React from "react";

interface LeftSidebarContextValue {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
}

const LeftSidebarContext = React.createContext<LeftSidebarContextValue | undefined>(
  undefined
);

export function LeftSidebarProvider({ children }: { children: React.ReactNode }) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <LeftSidebarContext.Provider value={{ isExpanded, setIsExpanded }}>
      {children}
    </LeftSidebarContext.Provider>
  );
}

export function useLeftSidebar() {
  const context = React.useContext(LeftSidebarContext);
  if (!context) {
    throw new Error("useLeftSidebar must be used within LeftSidebarProvider");
  }
  return context;
}
